import ColorSwatchGroup, { ColorOption } from 'client/widget-components/components/ColorSwatchGroup';
import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import type { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';
import React from 'react';

interface SelectionFilterColorItemProps {
    optChoices: ColorOption[];
    selectedFilterValues: Set<string | number>;
    onSelectValue: (value: string | number, selected: boolean) => void;
}

export default function SelectionFilterColorItem({ optChoices, selectedFilterValues, onSelectValue }: SelectionFilterColorItemProps) {
    const options = optChoices?.map((choice) => ({
        value: choice.value,
        color: choice.color || '',
    }));
    const selectedChoices = options.filter((option) => selectedFilterValues.has(option.value));

    return <ColorSwatchGroup
        options={options}
        selectedValue={selectedChoices}
        onChange={(value) => {
            onSelectValue(value.value, !selectedFilterValues.has(value.value));
        }}
        showLabels
        styles={{
            wrapper: wrapperDefaultStyles,
            inputWrapper: inputWrapperDefaultStyles,
            swatch: swatchDefaultStyles,
        }}
        size={24}
    />
}

const wrapperDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
    },
}

const inputWrapperDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
    },
}

const swatchDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        borderRadius: '50%',
    },
}